import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaint from "@/pages/ThankYouSaint";
export const Route = createFileRoute("/thank-you-saint-youtube")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          name: "robots",
          content: "noindex, follow",
        },
        {
          title: "Thank You | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thanks for reaching out about SAINT® TMS. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:title",
          content: "Thank You | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thanks for reaching out about SAINT® TMS. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you-saint-youtube",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you-saint-youtube",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouSaint google />;
}
